import * as analytics from '../vendor/analytics/index'

function parseFPTIValue(key) {

	const fptiData = JSON.parse(document.getElementById('fptiData').innerHTML || {});
	let nameValues = [];
	let pairs = decodeURIComponent(fptiData).split('&');
	let i;
	for (i = 0; i < pairs.length; i++) {
		let parts = pairs[i].split('=');
		nameValues[parts[0]] = parts[1];
	}
	return nameValues[key];
}


export function trackPage(pageGroup, pageName, custKey, custValue) {
	analytics.trackPage(pageGroup, pageName, custKey, custValue);
}

export function trackPageWithData(pageGroup, pageName, data) {
	analytics.trackPageWithData(pageGroup, pageName, data);
}

export function addPxpTags(data) {
	analytics.addPxpTags(data);
}

export function trackLinkClick(eventType) {
	analytics.trackLink(eventType, parseFPTIValue('pgrp'), parseFPTIValue('page'), 'link');
}

export function trackLinkClickWithData(eventType, data) {
	analytics.trackLinkWithData(eventType, parseFPTIValue('pgrp'), parseFPTIValue('page'), data, 'link');
}

export function trackButtonClick(eventType) {
	analytics.trackLink(eventType, parseFPTIValue('pgrp'), parseFPTIValue('page'), 'link');
}

export function trackButtonClickWithData(eventType, data) {
	analytics.trackLinkWithData(eventType, parseFPTIValue('pgrp'), parseFPTIValue('page'), data, 'link');
}

export function trackError(err) {
	analytics.trackError(err);
}



// WEBPACK FOOTER //
// ./utility/fpt.js